import { FormControl, FormLabel, Switch } from "@chakra-ui/react";
import { useState, useEffect, useContext } from "react";
import { apiRequest } from "utils/api";
import colors from "utils/colors";
import { FieldViewModel } from "./field.view-model";
import { SectionViewModel } from "../sections/section.view-model";
import { AlertsContext } from "providers/alerts";

interface HideFromBorrowersSwitchProps {
	fields: FieldViewModel[];
	section?: SectionViewModel | null;
	onHideFromBorrowers: (fields: FieldViewModel[]) => void;
}

export function HideFromBorrowersSwitch({
	fields,
	section,
	onHideFromBorrowers,
}: HideFromBorrowersSwitchProps) {
	const [hideFromBorrowers, setHideFromBorrowers] = useState(false);

	const { showSuccess } = useContext(AlertsContext);

	useEffect(() => {
		const hide = fields.every((field: any) => {
			return (
				!field.show_on_borrower_application && !field.show_on_borrower_loan
			);
		});
		setHideFromBorrowers(hide);
	}, [fields]);

	async function toogleHideFromBorrowers(hide: boolean) {
		await apiRequest("/supabase/loan_section/hide-from-borrowers", {
			fieldIds: fields.map((field) => field.id),
			hide: hide,
		});

		const changedFields = fields.map((field: FieldViewModel) => {
			return {
				...field,
				show_on_borrower_application: !hide,
				show_on_borrower_loan: !hide,
			};
		});

		onHideFromBorrowers(changedFields);

		showSuccess({
			title: "Section Fields Visibility Updated",
			description: "Section fields visibility was successfully updated",
		});
	}
	//////////////////////

	return (
		<FormControl display="flex" alignItems="center">
			<FormLabel
				htmlFor={`hide-from-borrowers-${section?.id}`}
				mb="0"
				fontSize="sm"
				fontWeight="bold"
				color={colors.GRAY_300}
				cursor="pointer"
			>
				Hide from borrowers
			</FormLabel>
			<Switch
				id={`hide-from-borrowers-${section?.id}`}
				size="sm"
				colorScheme="teal"
				isChecked={hideFromBorrowers}
				onChange={(ev) => toogleHideFromBorrowers(ev.target.checked)}
			/>
		</FormControl>
	);
}
